import { Grid } from '@mui/material';
import { usePageTitle } from '@hooks/usePageTitle';
import { Header } from '@layouts/Base/components/Header';
import { buildRoutePath } from '@navigation/buildRoutePath';
import { Routes } from '@navigation/routes';
import { VacancyData } from '@area/vacancy/components/VacancyData';
import indents from '@styles/indents.module.scss';

export const VacancyPage = () => {
  usePageTitle('Данные вакансии');

  return (
    <Grid container flexDirection="column" gap={indents.m}>
      <Grid item container flexDirection="column" gap={indents.xxs}>
        <Header
          title="Данные вакансии"
          backBtnTitle="Назад к списку вакансий"
          backBtnRoute={buildRoutePath([Routes.vacancy], {
            absolute: true,
          })}
        />
      </Grid>
      <Grid sx={{ width: '100%' }} item>
        <VacancyData />
      </Grid>
    </Grid>
  );
};
